import React from "react";
import Button from "@prism/button";

class CapturePhotoButton extends React.Component {
  render() {
    return (
      <Button
        id={this.props.id}
        className={this.props.className || "mx-2"}
        color={this.props.color}
        disabled={this.props.disabled}
        onClick={this.props.onClick}
      >
        <i className={`icon prism-icon-camera ${this.props.iconClassName || "text-secondary"}`} />
      </Button>
    );
  }
}

export default CapturePhotoButton;
